/* tslint:disable */
/* eslint-disable */
/**
 * 3DSurvey API
 * Frontend API for 3d Survey
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BarChartData } from './BarChartData';
import {
    BarChartDataFromJSON,
    BarChartDataFromJSONTyped,
    BarChartDataToJSON,
} from './BarChartData';

/**
 * 
 * @export
 * @interface GetNewUsersChartData200Response
 */
export interface GetNewUsersChartData200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GetNewUsersChartData200Response
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetNewUsersChartData200Response
     */
    error: string;
    /**
     * 
     * @type {BarChartData}
     * @memberof GetNewUsersChartData200Response
     */
    data: BarChartData;
}

/**
 * Check if a given object implements the GetNewUsersChartData200Response interface.
 */
export function instanceOfGetNewUsersChartData200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "success" in value;
    isInstance = isInstance && "error" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function GetNewUsersChartData200ResponseFromJSON(json: any): GetNewUsersChartData200Response {
    return GetNewUsersChartData200ResponseFromJSONTyped(json, false);
}

export function GetNewUsersChartData200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetNewUsersChartData200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': json['success'],
        'error': json['error'],
        'data': BarChartDataFromJSON(json['data']),
    };
}

export function GetNewUsersChartData200ResponseToJSON(value?: GetNewUsersChartData200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
        'error': value.error,
        'data': BarChartDataToJSON(value.data),
    };
}

